import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import thunk from "redux-thunk";
import notificationReducer from "./modules/common/redux/notificationSlice";
import authStateReducer from "./modules/auth/redux/authSlice";
import taskReducer from "./modules/tasks/redux/taskSlice";

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["notification", "task"],
};

const rootReducer = combineReducers({
  notification: notificationReducer,
  auth: authStateReducer,
  task: taskReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: [thunk],
});

export const persistor = persistStore(store);
